import Vue from 'vue';
import Editor from 'vue-editor-js/src';

Vue.use(Editor);
